import { useSelector } from 'react-redux';

import { capitalizeFirstLetter } from '../../../utils';
import type { CopilotState } from '../data-layer/types';

/**
 * Hook to get the application name from Copilot state
 */
export const useApplicationName = (): string => {
  const applicationName = useSelector(
    (state: { copilot: CopilotState }): string => {
      const generalFormData = state.copilot.stepFormData.General || {};
      const systemNameField = generalFormData['securitysystems.systemname'] as
        | { value?: string }
        | string
        | undefined;
      const name =
        (typeof systemNameField === 'object' && systemNameField.value) ||
        (typeof systemNameField === 'string' ? systemNameField : '') ||
        '';

      return name.toString();
    }
  );

  //  return applicationName.charAt(0).toUpperCase() + applicationName.slice(1);
  return capitalizeFirstLetter(applicationName);
};

export default useApplicationName;
